import React from "react";
import { Link } from "react-router-dom";
import {
  BarChart3,
  Search,
  Users,
  Church,
  Mail,
  HelpCircle,
  ChevronRight,
} from "lucide-react";
import styles from "../Dashboard.module.scss";

type Action = {
  label: string;
  to: string;
  external?: boolean;
  icon: React.ReactNode;
  iconBg: string;
};

export default function QuickActions({
  isFullAdmin,
}: {
  isFullAdmin: boolean;
}): JSX.Element {
  const actions: Action[] = [
    {
      label: "Quick Reports",
      to: "/quickReport",
      icon: <BarChart3 size={18} color="#285d8f" />,
      iconBg: "#e8f3fc",
    },
    {
      label: "Advanced Search",
      to: "/search_data",
      icon: <Search size={18} color="#1670bf" />,
      iconBg: "#eef6ff",
    },
    {
      label: isFullAdmin ? "Manage Couples" : "View Couples",
      to: "/manageCouples",
      icon: <Users size={18} color="#1f8a4c" />,
      iconBg: "#eafaf0",
    },
    {
      label: isFullAdmin ? "Manage Retreats" : "View Retreats",
      to: "/manageRetreat",
      icon: <Church size={18} color="#8a6300" />,
      iconBg: "#fff3d6",
    },
  ];

  if (isFullAdmin) {
    actions.push({
      label: "Broadcast Emails",
      to: "/sendEmail",
      icon: <Mail size={18} color="#66429a" />,
      iconBg: "#f0e8fa",
    });
  }

  actions.push({
    label: "Help",
    to: "https://lovestrongmarriage.com/?page_id=6",
    external: true,
    icon: <HelpCircle size={18} color="#c2410c" />,
    iconBg: "#ffedd5",
  });

  return (
    <div className={styles.actionsGrid}>
      {actions.map((action) => {
        const inner = (
          <>
            <span className={styles.actionIcon} style={{ background: action.iconBg }}>
              {action.icon}
            </span>
            <span className={styles.actionLabel}>{action.label}</span>
            <ChevronRight size={16} className={styles.actionChevron} />
          </>
        );
        return action.external ? (
          <a
            key={action.label}
            href={action.to}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.actionCard}
          >
            {inner}
          </a>
        ) : (
          <Link key={action.label} to={action.to} className={styles.actionCard}>
            {inner}
          </Link>
        );
      })}
    </div>
  );
}
